import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../components/fonts/font-props";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";


const MediaUploadCRmaFuqAnswer: React.FC = () => {
    const {getTranslation} = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    return (
        <FontBody2 color={FONT_COLOR.PRIMARY3_50}>{getTranslation("MEDIA_UPLOAD_IS_NOT_SUPPORTED", pageScope)}</FontBody2> 
    )
};

export default MediaUploadCRmaFuqAnswer;